import React from 'react';
import ImageWithFallback from '../image';
import Modal from '../modal';
import styles from './style.module.scss';
import SuccessTickIcon from '../../../public/images/alertModal/successTickIcon.svg';
import AlertIcon from '../../../public/images/alertModal/alertIcon.svg';
import ButtonWithLoader from '../buttonWithLoader';
import { StaticImageData } from 'next/image';
import Button from '@/shared/Button';

interface AlertModalProps {
  id?: string;
  open: boolean;
  classNames?: string;
  titleClassNames?: string;
  title: string;
  description_1?: string;
  description_2?: string;
  buttonText: string;
  onButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  severity: 'success' | 'error';
  onClose?: Function;
  showCloseButton?: boolean;
  isLoading?: boolean;
  icon?: React.ReactElement | StaticImageData;
}

export const AlertModal = (props: AlertModalProps) => {
  const {
    open,
    title,
    description_1,
    description_2,
    classNames,
    titleClassNames,
    buttonText,
    onButtonClick,
    severity,
    onClose,
    showCloseButton,
    isLoading,
    icon,
  } = props;

  const showDescription = description_1 || description_2;

  return (
    <Modal
      id="alertModal"
      open={open}
      showCloseButton={showCloseButton ? showCloseButton : false}
      showHeader={false}
      classNames={`md:w-[35rem] ${classNames}`}
      onClose={() => onClose && onClose()}
    >
      <div className="flex flex-col items-center justify-center pb-[1.875rem] md:pb-8">
        <ImageWithFallback
          data-testid="icon"
          src={icon ? icon : severity === 'success' ? SuccessTickIcon : AlertIcon}
          alt={severity === 'success' ? 'Success Tick Icon' : 'Alert Icon'}
          className={
            severity === 'success'
              ? 'mt-[1.375rem] ml-36 mr-[9.0625rem] w-[4.4375rem] h-[2.8125rem] md:mt-8 md:w-[6.804375rem] md:h-[4.25rem] md:mx-[14.125rem]'
              : 'mt-8 ml-[9.875rem] mr-[9.9375rem] w-[2.6875rem] h-[2.355rem] md:mt-8 md:w-[3.25rem] md:h-[2.875rem] md:mx-[15.875rem]'
          }
        />
        <div
          className={`
            ${
              severity === 'success'
                ? 'px-4 mt-6 md:mt-4 md:px-[4.75rem]'
                : !showDescription
                ? 'px-4 md:px-40 mt-4'
                : 'px-4 mt-[1.3325rem] md:mt-8 md:px-40'
            } ${titleClassNames}`}
        >
          <p
            className={`font-medium text-lg leading-6 text-center md:font-bold md:text-[1.375rem] md:leading-6 ${styles.successText}`}
            data-testid="title"
          >
            {title}
          </p>
        </div>
        {showDescription ? (
          <div
            className={`font-normal text-sm leading-[1.125rem] text-center px-[1.9375rem] md:px-0 mt-4 mb-[2.125rem] md:text-base md:leading-[1.5rem] md:mt-6 ${
              styles.successText
            } ${
              severity === 'success'
                ? 'md:pl-[7.4375rem] md:pr-[7.375rem] md:mb-9'
                : 'md:mb-8 md:w-[70%] w-[90%]'
            }  `}
          >
            <p className="description_1">{description_1}</p>
            <p className="description_2">{description_2}</p>
          </div>
        ) : (
          <span className="mt-6"></span>
        )}
        <div className="px-8 md:px-[8.25rem]">
          <Button
            dataTestId={`button-${buttonText}`}
            disabled={isLoading}
            onClick={onButtonClick}
            isLoading={isLoading}
            className={`uppercase w-[18.5rem] grid place-content-center md:max-h-12 ${
              isLoading ? 'pointer-events-none' : ''
            } ${styles.doneButton}`}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
